import { Injectable } from '@angular/core';
import { cacheable } from '@datorama/akita';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CardLinkOfferCategoriesStore } from '../card-link-offer-categories/card-link-offer-categories.store';
import { CardLinkOfferCategory } from '../card-link-offer-categories/models/card-link-offer-category.model';
import { ApiService } from '../shared/services/core/api.service';
import { CardLinkOffersStore } from './card-link-offers.store';
import { ActivateOffer } from './models/card-link-offer-activate.model';
import { CardLinkOffer } from './models/card-link-offer.model';

@Injectable({ providedIn: 'root' })
export class CardLinkOffersService {
  /** to set the offer id which user want to activate */
  constructor(
    private cardLinkOffersStore: CardLinkOffersStore,
    private cardLinkOfferCategoriesStore: CardLinkOfferCategoriesStore,
    private api: ApiService
  ) {}

  /** Fetch all the Offers and puts them in the store.*/
  fatchAffiliateOffer() {
    const request$: Observable<CardLinkOffer[]> = this.api.get<CardLinkOffer>(`affiliates/offers`).pipe(
      tap((offers) => {
        this.cardLinkOfferCategoriesStore.set(this.extractCategories(offers));
        this.cardLinkOffersStore.set(offers);
      })
    );
    return cacheable(this.cardLinkOffersStore, request$);
  }

  /**
   * activate offer by offer ID
   * @param offerId is the id of the offer which user want to activate.
   */
  activateOffer(offerId: number) {
    const request$: Observable<ActivateOffer> = this.api.post(`affiliates/offers/activate/${offerId}`, {}).pipe(
      tap((res) => {
        if (res.ErrorDesc == 'Success') {
          this.cardLinkOffersStore.update(offerId, { CustomerOfferStatus: 1 });
        }
      })
    );
    return request$;
  }

  /**
   * deactivate offer by offer ID
   * @param offerId is the id of the offer which user want to activate.
   */
  companiesClaim(offerId: Number) {
    const request$: Observable<ActivateOffer> = this.api.post(`companies/claim/${offerId}`, {});
    return request$;
  }

  /**
   * Extract the categories from the offer and return the categories
   * @param offers the list of offers.
   */
  extractCategories(offers: CardLinkOffer[]): CardLinkOfferCategory[] {
    let allCategoryTags: CardLinkOfferCategory[] = [];
    offers.forEach((offer) => {
      offer.CategoryTags?.forEach((categoryTag) => {
        if (allCategoryTags && !allCategoryTags.find((x) => x.TagId == categoryTag.TagId)) {
          allCategoryTags.push(categoryTag);
        }
      });
    });

    allCategoryTags.unshift({ TagId: 0, Name: 'All' });
    return allCategoryTags;
  }


 // fetchOfferLocations ()
}
